import React from 'react';

import type { Content, FilledLinkToMediaField } from '@prismicio/client';
import type { SliceComponentProps } from '@prismicio/react';
import { withEventScope } from '@repo/event-processor';
import { themeStyle } from '@repo/ui/theming';

import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import { getMediaCdnUrl } from 'global/prismicUtils';

import { Background, Image } from './styles';

const HeroImage: React.FC<SliceComponentProps<Content.HeroImageSlice>> = ({
  slice,
}) => {
  return (
    <Background
      className="hero-image"
      fullWidth={slice.primary.fullWidth}
      image={getMediaCdnUrl(slice.primary.backgroundImage?.url)}
    >
      {slice.variation === 'withVideo' ? (
        <VideoPlayer
          autoPlay={true}
          controls={false}
          loop={slice.primary.loop ?? true}
          muted={true}
          src={
            slice.primary.video
              ? getMediaCdnUrl(
                  (slice.primary.video as FilledLinkToMediaField).url
                )
              : undefined
          }
          theme={{
            maxWidth: slice.primary.customWidth || '800px',
            border:
              slice.primary.style === 'plain'
                ? 'none'
                : `${themeStyle.inkBase} solid 10px`,
            shadow:
              slice.primary.style === 'plain' ? 'none' : themeStyle.shadowSoft,
          }}
        />
      ) : (
        <Image
          alt={slice.primary.hero?.alt ?? undefined}
          customWidth={slice.primary.customWidth}
          imageStyle={slice.primary.style}
          src={getMediaCdnUrl(slice.primary.hero?.url) ?? undefined}
        />
      )}
    </Background>
  );
};

export default withEventScope(HeroImage, { feature: 'heroImage' });
